var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-alert',{attrs:{"color":"info","dense":"","text":""}},[_vm._v(" O valor percentual será aplicado sobre o valor total. ")]),_c('v-text-field',{attrs:{"label":"Valor percentual","type":"number","min":0.01,"step":0.01,"max":100,"outlined":"","dense":"","suffix":"%","rules":[
      (v) => !!v || 'Valor percentual é obrigatório',
      (v) => parseFloat(v) > 0 || 'Valor percentual deve ser maior que 0',
      (v) =>
        parseFloat(v) <= 100 ||
        'Valor percentual deve ser menor ou igual a 100',
    ],"hide-details":"auto"},model:{value:(_vm.price),callback:function ($$v) {_vm.price=$$v},expression:"price"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }